import { MapPinned, Sparkles, Zap } from "lucide-react";

const FEATURES = [
  {
    icon: MapPinned,
    overline: "01 · Coverage",
    title: "Pan-India Coverage",
    desc: "From Leh to Kanyakumari, Goa to Spiti — pick up and drop off across 40+ cities and key trailheads.",
    image:
      "https://images.unsplash.com/photo-1770319934109-4f71d9ef30ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxtb3RvcmN5Y2xlJTIwb24lMjBzY2VuaWMlMjByb2FkfGVufDB8fHx8MTc3ODY1NTcxMXww&ixlib=rb-4.1.0&q=85",
    alt: "Adventure motorcycle overlooking mountains",
  },
  {
    icon: Sparkles,
    overline: "02 · Fleet",
    title: "Activa to 1000cc",
    desc: "Daily scooters like Honda Activa & Suzuki Access, mid-range 350cc Royal Enfields, all the way up to 1000cc Kawasaki, BMW & Ducati superbikes.",
    image:
      "https://images.unsplash.com/photo-1761583780521-7723c3569361?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxtb3RvcmN5Y2xlJTIwY2xvc2UlMjB1cCUyMHdoZWVsJTIwZW5naW5lfGVufDB8fHx8MTc3ODY1NTcxMnww&ixlib=rb-4.1.0&q=85",
    alt: "Close-up of motorcycle wheel and engine",
  },
  {
    icon: Zap,
    overline: "03 · Booking",
    title: "Instant Booking",
    desc: "Book in 90 seconds. Aadhaar verified, transparent pricing, zero hidden fees, helmet and saddlebag included.",
    image: null,
  },
];

export const Features = () => {
  return (
    <section
      id="features"
      data-testid="features-section"
      className="relative bg-[#1e2528] py-24 md:py-32 scroll-mt-24 md:scroll-mt-28"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid md:grid-cols-12 gap-6 md:gap-10 items-end mb-16 md:mb-24">
          <div className="md:col-span-7">
            <div className="text-[10px] md:text-xs tracking-[0.3em] uppercase text-[#e89b1f] flex items-center gap-3 mb-6">
              <span className="inline-block w-8 h-px bg-[#e89b1f]" />
              What we're building
            </div>
            <h2 className="font-display uppercase text-[#f7f7f7] text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
              A rental experience
              <br />
              <span className="text-[#e89b1f]">built for riders.</span>
            </h2>
          </div>
          <p className="md:col-span-5 text-[#e6ebed]/70 text-base md:text-lg font-light leading-relaxed">
            Three things we obsess over so you can focus on the road ahead —
            the right machine, the right place, the right price.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-[#3e4b55]/60">
          {FEATURES.map((f, idx) => {
            const Icon = f.icon;
            return (
              <article
                key={f.title}
                data-testid={`feature-card-${idx}`}
                className="group relative bg-[#1e2528] p-8 md:p-10 lg:p-12 flex flex-col min-h-[420px] hover:bg-[#242c2f] transition-colors duration-500"
              >
                {f.image && (
                  <div className="relative w-full h-44 mb-8 overflow-hidden rounded-sm">
                    <img
                      src={f.image}
                      alt={f.alt}
                      className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-[#1e2528]/30 group-hover:bg-[#1e2528]/10 transition-colors" />
                  </div>
                )}
                {!f.image && (
                  <div className="w-full h-44 mb-8 border border-[#3e4b55] flex items-center justify-center rounded-sm relative overflow-hidden">
                    <Icon
                      className="w-16 h-16 text-[#e89b1f]/40 group-hover:text-[#e89b1f] group-hover:scale-110 transition-all duration-500"
                      strokeWidth={1.2}
                    />
                  </div>
                )}

                <div className="text-[10px] tracking-[0.3em] uppercase text-[#6f7c84] mb-4">
                  {f.overline}
                </div>
                <h3 className="font-display uppercase text-2xl sm:text-3xl text-[#e89b1f] tracking-tight mb-4">
                  {f.title}
                </h3>
                <p className="text-[#e6ebed]/70 text-sm md:text-base font-light leading-relaxed">
                  {f.desc}
                </p>

                <div className="mt-auto pt-8 flex items-center gap-2.5 text-[#ccd3d6]">
                  <Icon className="w-4 h-4 text-[#e89b1f]" strokeWidth={2} />
                  <span className="text-xs tracking-[0.2em] uppercase">
                    Launching soon
                  </span>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
